GP.models.Content = Backbone.Model.extend({
    idAttribute:'id',
    defaults:{
        content_id: null,
        content_media_id: null,
        duid: null,
        content_type: null,
        hide_from_feed: null,
        url: null,
        caption: null,
        rating: null,
        text: null,
        body: null,
        action_counts: null,
        comment_count: 0,
        like_count: 0,
        is_liked: null,
        ctime: null,
        placeholder_thumb: false,
        from_ajax: false,
        online_status: 'OFFLINE',
        content_na: null, // content not available,
        tags: [],
        has_deleted_comments: false,
        is_premium: false,
    },
    attr_types: {
        duid:             'int',
        content_id:       'int',
        content_media_id: 'int',
        comment_count:    'int',
        like_count:       'int',
        age:              'int',
        legacy_id:        'int',
        admin_reviewed:   'bool',
        action_counts: {
            COMMENT:      'int',
            LIKE_UNIQUE:  'int',
            VIEW:         'int',
            VIEW_UNIQUE:  'int'
        }
    },
    // override the "set" method for this model to ensure correct values types for attributes
    // matched in the attr_types object above
    set: function(attr, options) {
        if (typeof _gp_utils != 'undefined' && _gp_utils.bbm_ensure_types == 'function') {
            _gp_utils.bbm_ensure_types.apply(this, arguments);
        } else {
            Backbone.Model.prototype.set.apply(this, arguments);
        }
    },
    // could use $.proxy to return _gp_utils.bbm_ensure_types function with proper context
    // but would copy function for every model and most likely waste memory/cpu speed
    // set: $.proxy(_gp_utils.bbm_ensure_types, GP.models.Content),
    initialize: function(data, options) {
        this.set('comments', new GP.collections.Comments(data.comments));

        if (!_.isEmpty(data)) {
            if (GP.Util.check_obj(data.action_counts) && GP.Util.check_obj(data.action_counts.COMMENT)) {
                this.set('comment_count', data.action_counts.COMMENT);
            } else {
                this.set('comment_count', 0);
            }

            if (GP.Util.check_obj(data.action_counts) && GP.Util.check_obj(data.action_counts.LIKE_UNIQUE)) {
                this.set('like_count', data.action_counts.LIKE_UNIQUE);
            } else {
                this.set('like_count', 0);
            }
        }
    }
});
